import { Component } from 'react';
import PropTypes from 'prop-types';

class MemberDevices extends Component {
  render() {
    const { devices } = this.props;
    return devices ? JSON.stringify(devices) : '-';
  }
}

MemberDevices.propTypes = {
  devices: PropTypes.shape({}),
};

MemberDevices.defaultProps = {
  devices: '',
};

export default MemberDevices;
